import { normalize } from 'normalizr';
import * as schema from '../schema';
import * as actionTypes from './actionTypes';
import { axiosProtected } from '../../axios-wizard';
import { fetchProjectSuccess, initProject } from './projects';
import { fetchProjectOfferPositions } from './productsolutions';

export const cloneProjectunit = (title, description, description_long, notice, projectunitId) => {
    const url = '/api/projectunits/' + projectunitId + '/clone'
    return dispatch => {
        dispatch({
          type: actionTypes.CLONE_PROJECTUNIT_START
        });
        return axiosProtected.post( url, {title: title, description: description, description_long: description_long, notice: notice} )
            .then( response => {
               const normalizedProject = normalize(response.data, { project: schema.project })
               dispatch({
                 type: actionTypes.CLONE_PROJECTUNIT_SUCCESS
               });
               dispatch(fetchProjectSuccess(normalizedProject));
            } )
            .catch( error => {
                dispatch({
                  type: actionTypes.CLONE_PROJECTUNIT_FAILED
                });
            } );
    };
};


export const createProjectunitStart = (  ) => {
    return {
        type: actionTypes.CREATE_PROJECTUNIT_START
    };
};

const createProjectunitSuccess = ( projectunit ) => {
    return {
        type: actionTypes.CREATE_PROJECTUNIT_SUCCESS,
        values: projectunit
    };
};

const createProjectunitFailed = () => {
    return {
        type: actionTypes.CREATE_PROJECTUNIT_FAILED
    };
};


export const createProjectunit = (projectunit) => {
    const url = '/api/projectunits'
    return dispatch => {
        dispatch( createProjectunitStart() );
        return axiosProtected.post( url, projectunit )
            .then( response => {
               const normalizedProjectunit = normalize(response.data, { projectunits: schema.arrayOfProjects })
               dispatch(createProjectunitSuccess(normalizedProjectunit));
               dispatch(initProject(projectunit.project_id));
            } )
            .catch( error => {
                dispatch(createProjectunitFailed());
            } );
    };
};





export const updateProjectunitStart = (  ) => {
    return {
        type: actionTypes.UPDATE_PROJECTUNIT_START
    };
};

const updateProjectunitSuccess = ( projectunit ) => {
    return {
        type: actionTypes.UPDATE_PROJECTUNIT_SUCCESS,
        values: projectunit
    };
};

const updateProjectunitFailed = () => {
    return {
        type: actionTypes.UPDATE_PROJECTUNIT_FAILED
    };
};


export const updateProjectunit = (projectunit) => {
    const url = '/api/projectunits/' + projectunit.id
    return dispatch => {
        dispatch( updateProjectunitStart() );
        return axiosProtected.put( url, projectunit )
            .then( response => {
               const normalizedData = normalize(response.data, { projectunit: schema.projectunit })
               dispatch(updateProjectunitSuccess(normalizedData));
               dispatch(initProject(projectunit.project_id));
            } )
            .catch( error => {
                dispatch(updateProjectunitFailed());
            } );
    };
};


export const deleteProjectunitStart = (  ) => {
    return {
        type: actionTypes.DELETE_PROJECTUNIT_START
    };
};

const deleteProjectunitSuccess = ( projectunit ) => {
    return {
        type: actionTypes.DELETE_PROJECTUNIT_SUCCESS,
        values: projectunit
    };
};

const deleteProjectunitFailed = () => {
    return {
        type: actionTypes.DELETE_PROJECTUNIT_FAILED
    };
};


export const deleteProjectunit = (projectunit) => {

    const url = '/api/projectunits/' + projectunit.id
    return dispatch => {
        dispatch( deleteProjectunitStart() );
        return axiosProtected.delete( url, projectunit )
            .then( response => {
               const normalizedProject = normalize(response.data, { projectunit: schema.projectunit })
               dispatch(deleteProjectunitSuccess(normalizedProject));
               dispatch(initProject(projectunit.project_id));
            } )
            .then( dispatch(fetchProjectOfferPositions(projectunit.project_id)))
            .catch( error => {
                dispatch(deleteProjectunitFailed());
            } );
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/projectunits.js